<template>
	<div style="margin-top: -70px">
		<el-row>
			<el-col :span="5" :offset="8">
				<div style="border: 1px solid; border-radius: 12px">
					<div
						style="
							border-top-left-radius: 12px;
							border-top-right-radius: 12px;
							border: 1px solid;
							height: 20px;
							background-color: white;
							text-align: center;
							color: black;
						"
					>
						<el-row :gutter="0">
							<el-col :span="3">
								<span style="font-weight: 600; font-size: 12px">{{
									date
								}}</span>
							</el-col>
							<el-col :span="2" :offset="15">
								<img width="15px" src="../../../assets/icons/net.png" />
							</el-col>
							<el-col :span="2">
								<img width="15px" src="../../../assets/icons/wifi.png" />
							</el-col>
							<el-col style="margin-top: 2px" :span="2">
								<img width="15px" src="../../../assets/icons/battery.jpg" />
							</el-col>
						</el-row>
					</div>
					<div
						style="
							border: 1px solid;
							height: 30px;
							background-color: black;
							text-align: center;
							color: white;
							padding-top: 5px;
							margin-top: -1px;
							margin-right: -1px;
							margin-left: -1px;
							border-color: #333333;
						"
					>
						Form
					</div>
					<img
						style="border-left: 1px solid; border-right: 1px solid"
						src="../../../assets/images/locationsearch.png"
					/>
					<div
						style="
							text-align: left;
							background-color: #f6f7f9;
							height: 30px;
							color: black;
							padding-top: 5px;
							border: 1px solid;
							border-color: #333333;
							border-top: none;
						"
					>
						<div style="margin-left: 5px">Task - {{ title }}</div>
					</div>
					<div
						style="
							background-color: black;
							height: 30px;
							text-align: left;
							padding-top: 5px;
						"
					>
						<div style="margin-left: 5px; color: white">
							Steps - 0 of 2 completed
						</div>
					</div>
					<el-row
						style="
							margin-top: 0px;
							background-color: #f6f7f9;
							text-align: left;
							overflow-y: auto;
							border-left: 1px solid;
							border-right: 1px solid;
							border-color: #333333;
						"
						class="pl-1 pr-1"
					>
						<el-col style="min-height: 45vh; max-height: 45vh" :span="24">
							<div v-for="(itemS, idxS) in preview_formItemArray" :key="idxS">
								<el-row>
									<el-col class="my-1 ml-3" :span="24">
										<div style="font-weight: bold; color: black">
											{{ idxS + 1 }}. {{ itemS.name }}
										</div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="24">
										<el-col style="font-size: 10px" :span="24">
											<el-row>
												<el-col :span="24">
													<el-row
														v-for="(item, idx) in itemS.form_questions_list"
														:key="idx"
													>
														<el-col :span="24">
															<div
																style="
																	border: 1px solid;
																	margin-bottom: 5px;
																	border-radius: 0px;
																	font-size: 12px;
																	border-color: white;
																"
															>
																<el-card shadow="never">
																	<el-row style="margin-top: -5px" :gutter="0">
																		<el-col
																			style="margin-top: -10px"
																			v-if="
																				item.input_type_info.name == 'Yes / No'
																			"
																			:span="4"
																			:offset="20"
																		>
																			<div
																				v-if="
																					scoringType == 'Score for each step'
																				"
																				style="font-size: 9px; font-weight: 600"
																			>
																				Points - {{ item.total_points }}
																			</div>
																		</el-col>
																	</el-row>
																	<el-row style="margin-top: 0px">
																		<el-col
																			:span="
																				item.input_type_info.name == 'Checklist'
																					? 3
																					: 2
																			"
																			:offset="0"
																		>
																			<span
																				style=""
																				:style="
																					item.input_type_info.name ==
																					'Checklist'
																						? 'margin-left: 0px'
																						: 'margin-left: 0px'
																				"
																			>
																				<input
																					v-if="
																						item.input_type_info.name ==
																						'Checklist'
																					"
																					type="checkbox"
																					:disabled="item.marked_as_na"
																					style="width: 17px; height: 17px"
																				/>

																				<b
																					:style="
																						item.input_type_info.name ==
																						'Checklist'
																							? 'margin-left:10px'
																							: ''
																					"
																					>{{ idx + 1 }}.
																				</b>
																			</span>
																		</el-col>
																		<el-col
																			:span="
																				item.input_type_info.name == 'Checklist'
																					? 21
																					: 22
																			"
																			:offset="0"
																		>
																			<div
																				:style="
																					item.input_type_info.name ==
																					'Checklist'
																						? 'margin-left: 0px'
																						: 'margin-left: 0px'
																				"
																				style="font-size: 10px"
																			>
																				{{ item.name }}
																			</div>
																		</el-col>
																	</el-row>
																	<el-row style="margin-top: 5px">
																		<el-col :span="22" :offset="2">
																			<div
																				style="font-size: 13px"
																				v-html="item.description"
																			></div>
																		</el-col>
																	</el-row>
																	<el-row
																		v-if="
																			item.form_question_attachments_list
																				.length != 0
																		"
																		style="margin-top: 10px"
																	>
																		<el-col :span="2" :offset="1">
																			<span>
																				<div
																					@click="
																						item.form_question_attachments_list
																							.length != 0
																							? get_image(
																									item.form_question_attachments_list
																							  )
																							: ''
																					"
																					style="
																						color: #f9a168;
																						font-size: 13px;
																					"
																				>
																					<b><u>View Media</u></b>
																				</div>
																			</span>
																		</el-col>
																		<el-col :span="1">
																			<img
																				width="15px"
																				src="../../../assets/icons/Attach.png"
																			/>
																		</el-col>
																	</el-row>
																	<!-- types -->
																	<el-row
																		style="margin-top: 10px"
																		v-if="
																			item.input_type_info.name == 'Yes / No'
																		"
																	>
																		<el-col
																			style="margin-left: -40px"
																			:span="20"
																			:offset="0"
																		>
																			<el-button
																				class="button-class-white-dialog"
																				size="mini"
																				style="height: 30px"
																			>
																				Yes
																			</el-button>
																			<el-button
																				class="button-class-white-dialog"
																				size="mini"
																				style="height: 30px"
																			>
																				No
																			</el-button>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 10px"
																		v-if="
																			item.input_type_info.name == 'Long Text'
																		"
																	>
																		<el-col :span="23" :offset="1">
																			<el-input
																				:disabled="item.marked_as_na"
																				type="textarea"
																				:rows="2"
																				placeholder="Enter long description"
																				v-model="item.text_input"
																				class="input-class"
																			>
																			</el-input>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 10px"
																		v-if="
																			item.input_type_info.name == 'Short text'
																		"
																	>
																		<el-col :span="16" :offset="1">
																			<el-input
																				:disabled="item.marked_as_na"
																				type="text"
																				v-model="item.text_input"
																				placeholder="Enter short description"
																				class="input-class"
																			/>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 10px"
																		v-if="
																			item.input_type_info.name ==
																			'Number input'
																		"
																	>
																		<el-col :span="16" :offset="1">
																			<el-input
																				:disabled="item.marked_as_na"
																				type="text"
																				v-model="item.number_input"
																				placeholder="Enter number"
																				class="input-class"
																			/>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 5px"
																		v-if="
																			item.input_type_info.name == 'Temperature'
																		"
																	>
																		<el-col :span="10" :offset="1">
																			<span>Test Value</span>
																		</el-col>
																		<el-col :span="16">
																			<span>
																				<el-input
																					:disabled="item.marked_as_na"
																					type="text"
																					v-model="item.number_input"
																					placeholder="Enter Temperature"
																					style="background: white"
																					class="input-class"
																				/>
																			</span>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 5px"
																		v-if="
																			item.input_type_info.name == 'Temperature'
																		"
																	>
																		<el-col :span="10" :offset="1">
																			<span>Retest Value</span>
																		</el-col>
																		<el-col :span="16">
																			<span>
																				<el-input
																					:disabled="item.marked_as_na"
																					type="text"
																					v-model="item.repeat_number_input"
																					placeholder="Enter Temperature"
																					style="background: white"
																					class="input-class"
																				/>
																			</span>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 5px"
																		v-if="item.input_type_info.name == 'TPM'"
																	>
																		<el-col :span="10" :offset="1">
																			<span>Test Value</span>
																		</el-col>
																		<el-col :span="16">
																			<span>
																				<el-input
																					:disabled="item.marked_as_na"
																					type="text"
																					v-model="item.number_input"
																					placeholder="Enter TPM"
																					style="background: white"
																					class="input-class"
																				/>
																			</span>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 5px"
																		v-if="item.input_type_info.name == 'TPM'"
																	>
																		<el-col :span="10" :offset="1">
																			<span>Retest Value</span>
																		</el-col>
																		<el-col :span="16">
																			<span>
																				<el-input
																					:disabled="item.marked_as_na"
																					type="text"
																					v-model="item.repeat_number_input"
																					placeholder="Enter TPM"
																					style="background: white"
																					class="input-class"
																				/>
																			</span>
																		</el-col>
																	</el-row>
																	<div
																		style="margin-top: 10px"
																		v-if="
																			item.input_type_info.name ==
																			'Select any one'
																		"
																	>
																		<el-row
																			v-for="(
																				obj, key
																			) in item.input_options_list"
																			:key="key"
																			class="mb-3 mt-3"
																		>
																			<el-col :span="20" :offset="1">
																				<el-radio-group>
																					<el-radio :label="obj.name">{{
																						obj.name
																					}}</el-radio>
																				</el-radio-group>
																				<span
																					style="
																						font-size: 12px;
																						margin-left: 30px;
																					"
																				>
																					<b>Points - {{ obj.value }}</b>
																				</span>
																			</el-col>
																		</el-row>
																	</div>
																	<div
																		style="margin-top: 10px"
																		v-if="
																			item.input_type_info.name == 'Multiselect'
																		"
																	>
																		<el-row
																			class="mt-3 mb-3"
																			v-for="(
																				obj, key
																			) in item.input_options_list"
																			:key="key"
																		>
																			<el-col :span="3" :offset="1">
																				<input
																					:disabled="item.marked_as_na"
																					type="checkbox"
																					style="width: 17px; height: 17px"
																				/>
																			</el-col>
																			<el-col :span="20" :offset="1">
																				<span
																					style="
																						margin-top: -3px;
																					"
																				>
																					{{ obj.name }}
																					<span
																						style="
																							margin-top: -15px;
																							margin-left: 30px;
																							font-size: 12px;
																						"
																					>
																						<b>Points - {{ obj.value }}</b>
																					</span>
																				</span>
																			</el-col>
																		</el-row>
																	</div>
																	<el-row
														style="margin-top: 10px"
														v-if="
															item.input_type_info.name ==
															'Date'
														"
													>
														<el-col :span="23" :offset="1">
															<el-date-picker
																style="margin-top: 10px; width: 95%"
																v-model="item.date_input"
																type="date"
																placeholder="Select Date"
																class="date"
																format="yyyy-MM-dd"
																value-format="yyyy-MM-dd"
															>
															</el-date-picker>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="
															item.input_type_info.name ==
															'Time'
														"
													>
														<el-col :span="23" :offset="1">
															<el-time-select
																v-model="item.time_input"
																:picker-options="{
																	start: '00:00',
																	step: '00:15',
																	end: '23:45',
																}"
																placeholder="Select time"
																class="date"
															>
															</el-time-select>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="
															item.input_type_info.name ==
															'Datetime'
														"
													>
														<el-col :span="23" :offset="1">
															<el-date-picker
																style="margin-top: 10px; width: 95%"
																v-model="item.date"
																type="datetime"
																placeholder="Select Date & Time"
																class="date"
																format="yyyy-MM-dd HH:mm"
															>
															</el-date-picker>
														</el-col>
													</el-row>
													<el-row
													v-if="item.input_type_info.name === 'Timer'"
													style="margin-top: 10px"
												>
													<el-col :span="23" :offset="1">
														<div style="font-size:10px;display:flex; width:50%"
															v-for="(
																attempt, attemptIndex
															) in item.timer_attempts"
															:key="attemptIndex"
														>
															<div style="font-size:10px" >
																Time {{ attemptIndex + 1 }}
															</div>
															<span
															
																class="stopwatch"
															>
																00:00:00
															</span>

															
														</div>
													</el-col>
												</el-row>
												<el-row
													v-if="item.input_type_info.name === 'Timer'"
													style="margin-top: 10px"
												>
													<el-col :span="24" :offset="1">
														<div style="font-size:10px;display:flex; width:50%">
															<div>Total Time:</div>
															<div
																class="stopwatch"
																style="margin-left: 98px"
															>
																<strong>00:00:00</strong>
															</div>
														</div>
														<div style="font-size:10px;display:flex; width:50%">
															<div >Average Time:</div>
															<div
																class="stopwatch"
																style="margin-left: 85px"
															>
																<strong>00:00:00</strong>
															</div>
														</div>
													</el-col>
												</el-row>
																	<el-row
																		style="margin-top: 10px"
																		v-if="item.input_type_info.name == 'Rating'"
																	>
																		<el-col :span="2" :offset="1">
																			<div>
																				{{ item.minimum_value }}
																			</div>
																		</el-col>
																		<el-col :span="16">
																			<span>
																				<el-slider
																					:disabled="item.marked_as_na"
																					v-model="item.rating"
																					:min="item.minimum_value"
																					:max="item.maximum_value"
																					show-stops
																				>
																				</el-slider>
																			</span>
																		</el-col>
																		<el-col :span="2" :offset="1">
																			<div>
																				{{ item.maximum_value }}
																			</div>
																		</el-col>
																	</el-row>
																	<el-row
																		v-if="
																			item.input_type_info.name ==
																			'Mobile number'
																		"
																	>
																		<el-col :span="4" :offset="1">
																			<input
																				type="number"
																				pattern="/^-?\d+\.?\d*$/"
																				onKeyPress="if(this.value.length==10) return false;"
																				v-model="item.phone_number"
																				placeholder="Enter Mobile Number"
																				class="input-class-dialog mt-2"
																				style="width: 300px"
																			/>
																		</el-col>
																	</el-row>
																	<el-row
																		v-if="item.input_type_info.name == 'Email'"
																	>
																		<el-col :span="4" :offset="1">
																			<input
																				v-model="item.email"
																				type="email"
																				id="email"
																				name="email"
																				class="input-class-dialog mt-2"
																				style="width: 300px"
																				placeholder="example@example.com"
																			/>
																		</el-col>
																	</el-row>
																	<!-- types close -->
																	<el-row
																		style="
																			margin-top: 5px;
																			margin-bottom: -15px;
																		"
																	>
																		<el-col :span="2" :offset="12">
																			<img
																				width="25px"
																				src="../../../assets/icons/Camera.png"
																			/>
																		</el-col>
																		<el-col :span="2" :offset="1">
																			<img
																				width="25px"
																				src="../../../assets/icons/Comment1.png"
																			/>
																		</el-col>
																		<el-col :span="2" :offset="1">
																			<img
																				width="25px"
																				src="../../../assets/icons/ComputerSupport1.png"
																			/>
																		</el-col>
																		<el-col :span="1" :offset="1">
																			<el-switch
																				v-model="item.marked_as_na"
																				active-color="#41BE62"
																			>
																			</el-switch>
																		</el-col>
																	</el-row>
																	<!-- Dependent Question Start -->
																	<el-row
																		style="margin-top: 10px"
																		v-if="item.dependant_question_available"
																	>
																		<el-col :span="22" :offset="1">
																			<el-row v-if="item.expanded == true">
																				<el-col class="mt-2" :span="1">
																					<img
																						width="25px"
																						src="../../../assets/icons/Link.png"
																					/>
																				</el-col>
																				<el-col :span="23">
																					<el-card
																						style="
																							border: 1px dashed;
																							border-color: #f9a168;
																							border-radius: 12px;
																							background-color: #fff9f4;
																						"
																						@click.native="collapse_item(item)"
																					>
																						<el-row style="cursor: pointer">
																							<el-col
																								v-if="
																									item
																										.child_form_questions_list[0]
																										.input_type_info.name ==
																									'Checklist'
																								"
																								:span="4"
																							>
																								<input
																									type="checkbox"
																									style="
																										width: 17px;
																										height: 17px;
																									"
																								/>
																							</el-col>
																							<el-col
																								:style="
																									item
																										.child_form_questions_list[0]
																										.input_type_info.name ==
																									'Checklist'
																										? 'margin-top: -2px; margin-left:-20px'
																										: ''
																								"
																								:span="
																									item
																										.child_form_questions_list[0]
																										.input_type_info.name ==
																									'Checklist'
																										? 20
																										: 22
																								"
																							>
																								<div>
																									{{
																										item
																											.child_form_questions_list[0]
																											.name
																									}}
																								</div>
																							</el-col>
																							<el-col :span="1">
																								<el-button
																									icon="el-icon-arrow-down"
																									style="
																										border: none;
																										color: black;
																										font-size: 12px;
																										margin-top: -30px;
																										background-color: #fff9f4;
																									"
																									plain
																								>
																								</el-button>
																							</el-col>
																						</el-row>
																						<el-row
																							style="margin-top: 10px"
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Yes / No'
																							"
																						>
																							<el-col
																								style="margin-left: -40px"
																								:span="16"
																							>
																								<el-button
																									class="button-class-white-dialog"
																									size="mini"
																								>
																									Yes
																								</el-button>
																								<el-button
																									size="mini"
																									class="button-class-white-dialog"
																								>
																									No
																								</el-button>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Long text'
																							"
																						>
																							<el-col :span="23" :offset="1">
																								<el-input
																									:disabled="item.marked_as_na"
																									type="textarea"
																									:rows="2"
																									placeholder="Enter long description"
																									v-model="item.text_input"
																									class="input-class"
																								>
																								</el-input>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Short text'
																							"
																						>
																							<el-col :span="19" :offset="1">
																								<el-input
																									:disabled="item.marked_as_na"
																									type="text"
																									v-model="item.text_input"
																									placeholder="Enter short description"
																									class="input-class"
																								/>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Number input'
																							"
																						>
																							<el-col :span="19">
																								<el-input
																									:disabled="item.marked_as_na"
																									type="text"
																									v-model="item.number_input"
																									placeholder="Enter number"
																									class="input-class"
																								/>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Temperature'
																							"
																						>
																							<el-col :span="10">
																								<span>Test Value</span>
																							</el-col>
																							<el-col :span="19">
																								<span>
																									<el-input
																										:disabled="
																											item.marked_as_na
																										"
																										type="text"
																										v-model="item.number_input"
																										placeholder="Enter Temperature"
																										class="input-class"
																									/>
																								</span>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Temperature'
																							"
																							style="margin-top: 5px"
																						>
																							<el-col :span="10" :offset="0">
																								<span>Retest Value</span>
																							</el-col>
																							<el-col :span="19">
																								<span>
																									<el-input
																										:disabled="
																											item.marked_as_na
																										"
																										type="text"
																										v-model="item.number_input"
																										placeholder="Enter Temperature"
																										class="input-class"
																									/>
																								</span>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name == 'TPM'
																							"
																						>
																							<el-col :span="10">
																								<span>Test Value</span>
																							</el-col>
																							<el-col :span="19">
																								<span>
																									<el-input
																										:disabled="
																											item.marked_as_na
																										"
																										type="text"
																										v-model="item.number_input"
																										placeholder="Enter TPM"
																										class="input-class"
																									/>
																								</span>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name == 'TPM'
																							"
																							style="margin-top: 5px"
																						>
																							<el-col :span="10" :offset="0">
																								<span>Retest Value</span>
																							</el-col>
																							<el-col :span="19">
																								<span>
																									<el-input
																										:disabled="
																											item.marked_as_na
																										"
																										type="text"
																										v-model="item.number_input"
																										placeholder="Enter TPM"
																										class="input-class"
																									/>
																								</span>
																							</el-col>
																						</el-row>
																						<div
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Select any one'
																							"
																						>
																							<el-row
																								v-for="(obj, key) in item
																									.child_form_questions_list[0]
																									.input_options_list"
																								:key="key"
																								class="mb-3 mt-3"
																							>
																								<el-col :span="23">
																									<el-radio-group>
																										<el-radio
																											:label="obj.name"
																											>{{ obj.name }}</el-radio
																										>
																									</el-radio-group>
																									<span
																										style="
																											font-size: 12px;
																											margin-left: 30px;
																										"
																									>
																										<b
																											>Points -
																											{{ obj.value }}</b
																										>
																									</span>
																								</el-col>
																								<!-- <el-col :span="3"> </el-col> -->
																							</el-row>
																						</div>
																						<div
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Multiselect'
																							"
																						>
																							<el-row
																								class="mt-3 mb-3"
																								v-for="(obj, key) in item
																									.child_form_questions_list[0]
																									.input_options_list"
																								:key="key"
																							>
																								<el-col :span="3">
																									<input
																										type="checkbox"
																										style="
																											width: 17px;
																											height: 17px;
																										"
																									/>
																								</el-col>
																								<el-col :span="20">
																									<span
																										style="margin-top: -3px"
																									>
																										{{ obj.name }}
																									</span>
																									<span
																										style="
																											margin-top: -10px;
																											margin-left: 40px;
																											font-size: 12px;
																										"
																									>
																										<b
																											>Points -
																											{{ obj.value }}</b
																										>
																									</span>
																								</el-col>
																								<!-- <el-col :span="5"> </el-col> -->
																							</el-row>
																						</div>
																						<el-row
																							style="margin-top: 10px"
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Date'
																							"
																						>
																							<el-col :span="4">
																								<el-date-picker
																									v-model="item.dependent_date"
																									type="date"
																									placeholder="Select Date"
																									default-value="2010-10-01"
																								>
																								</el-date-picker>
																							</el-col>
																						</el-row>
																						<el-row
																							style="margin-top: 10px"
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Date and Time'
																							"
																						>
																							<el-col :span="4">
																								<el-date-picker
																									v-model="item.dependent_date"
																									type="date"
																									placeholder="Select Date"
																									default-value="2010-10-01"
																								>
																								</el-date-picker>
																							</el-col>
																							<el-col :span="2" :offset="1">
																								<el-time-select
																									v-model="item.dependent_time"
																									:picker-options="{
																										start: '00:00',
																										step: '00:30',
																										end: '23:45',
																									}"
																									placeholder="Select time"
																								>
																								</el-time-select>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Rating'
																							"
																						>
																							<el-col :span="2">
																								<div>
																									<!-- {{ item }} -->
																									{{
																										item
																											.child_form_questions_list[0]
																											.minimum_value
																									}}
																								</div>
																							</el-col>
																							<el-col :span="19">
																								<span>
																									<el-slider
																										v-model="
																											item.dependent_rating
																										"
																										:min="
																											item
																												.child_form_questions_list[0]
																												.minimum_value
																										"
																										:max="
																											item
																												.child_form_questions_list[0]
																												.maximum_value
																										"
																										show-stops
																									>
																									</el-slider>
																								</span>
																							</el-col>
																							<el-col :span="2" :offset="1">
																								<div>
																									{{
																										item
																											.child_form_questions_list[0]
																											.maximum_value
																									}}
																								</div>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Phone Number'
																							"
																						>
																							<el-col :span="4">
																								<input
																									type="number"
																									pattern="/^-?\d+\.?\d*$/"
																									onKeyPress="if(this.value.length==10) return false;"
																									v-model="
																										item.dependent_phone_number
																									"
																									placeholder="Enter Phone Number"
																									class="input-class-dialog mt-2"
																									style="width: 300px"
																								/>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_questions_list[0]
																									.input_type_info.name ==
																								'Email'
																							"
																						>
																							<el-col :span="4">
																								<input
																									v-model="item.dependent_email"
																									type="email"
																									id="email"
																									name="email"
																									class="input-class-dialog mt-2"
																									style="width: 300px"
																									placeholder="example@example.com"
																								/>
																							</el-col>
																						</el-row>
																						<el-row style="margin-top: 5px">
																							<el-col :span="2" :offset="12">
																								<img
																									width="25px"
																									src="../../../assets/icons/Camera.png"
																								/>
																							</el-col>
																							<el-col :span="2" :offset="1">
																								<img
																									width="25px"
																									src="../../../assets/icons/Comment1.png"
																								/>
																							</el-col>
																							<el-col :span="2" :offset="1">
																								<img
																									width="25px"
																									src="../../../assets/icons/ComputerSupport1.png"
																								/>
																							</el-col>
																							<el-col :span="2" :offset="1">
																								<el-switch
																									v-model="item.marked_as_na"
																									active-color="#41BE62"
																								>
																								</el-switch>
																							</el-col>
																						</el-row>
																					</el-card>
																				</el-col>
																			</el-row>
																			<div v-if="item.expanded == false">
																				<el-row>
																					<el-col class="mt-2" :span="1">
																						<img
																							width="25px"
																							src="../../../assets/icons/Link.png"
																						/>
																					</el-col>
																					<el-col :span="23">
																						<el-card
																							style="
																								border: 1px dashed;
																								border-color: #f9a168;
																								height: 60px;
																								border-radius: 12px;
																								background-color: #fff9f4;
																							"
																							@click.native="expand_item(item)"
																						>
																							<el-row
																								style="
																									cursor: pointer;
																									margin-top: -10px;
																								"
																							>
																								<el-col
																									v-if="
																										item
																											.child_form_questions_list[0]
																											.input_type_info.name ==
																										'Checklist'
																									"
																									:span="2"
																								>
																									<input
																										type="checkbox"
																										style="
																											width: 17px;
																											height: 17px;
																										"
																									/>
																								</el-col>
																								<el-col
																									:span="
																										item
																											.child_form_questions_list[0]
																											.input_type_info.name ==
																										'Checklist'
																											? 21
																											: 22
																									"
																								>
																									<div>
																										{{
																											item
																												.child_form_questions_list[0]
																												.name
																										}}
																									</div>
																								</el-col>
																								<el-col :span="2">
																									<el-button
																										icon="el-icon-arrow-right"
																										style="
																											border: none;
																											color: black;
																											font-size: 12px;
																											background-color: #fff9f4;
																										"
																										plain
																									>
																									</el-button>
																								</el-col>
																							</el-row>
																						</el-card>
																					</el-col>
																				</el-row>
																			</div>
																		</el-col>
																	</el-row>
																	<!-- Dependent Question End -->
																</el-card>
															</div>
														</el-col>
													</el-row>
												</el-col>
											</el-row>
										</el-col>
									</el-col>
								</el-row>
							</div>
						</el-col>
					</el-row>
					<div
						style="
							background-color: #f6f7f9;
							height: 40px;
							border-left: 1px solid;
							border-right: 1px solid;
							border-color: #333333;
						"
					>
						<el-row>
							<el-col :span="2" :offset="3">
								<el-button style="width: 70%" class="button-class">
									Update
								</el-button>
							</el-col>
						</el-row>
					</div>
					<div
						style="
							border: 1px solid;
							border-bottom-left-radius: 12px;
							border-bottom-right-radius: 12px;
							height: 30px;
							background-color: black;
						"
					></div>
					<!-- </div> -->
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	props: {
		preview_formItemArray: Array,
		title: String,
		scoringType: String,
	},
	data: () => ({
		new_formItemArray: [],
		date: "",
	}),
	mounted() {
		this.date = new Date().toLocaleTimeString("en-in", {
			hour: "2-digit",
			minute: "2-digit",
			hour12: false,
		});
		// console.log(, "preview_formItemArray");
	},
	methods: {
		collapse_item(item) {
			item.expanded = !item.expanded;
			this.$forceUpdate();
			return item;
		},
		expand_item(item) {
			item.expanded = !item.expanded;
			this.$forceUpdate();
			return item;
		},
	},
};
</script>

<style></style>
